'use client';

import { Flex, Tabs, Typography } from 'antd';
import type { TabsProps } from 'antd';
import type { ReactNode } from 'react';

const { Text, Paragraph } = Typography;

type PageTabsProps = {
  items: TabsProps['items'];
  activeKey: string;
  onChange: (key: string) => void;
  icon: ReactNode;
  title: string;
  description?: string;
};

export function PageTabs({
  items,
  activeKey,
  onChange,
  icon,
  title,
  description,
}: PageTabsProps) {
  return (
    <Flex vertical gap={16}>
      <Flex align="center" gap={10}>
        {icon}
        <div>
          <Text strong style={{ fontSize: 16, display: 'block' }}>
            {title}
          </Text>
          {description && (
            <Paragraph type="secondary" style={{ margin: 0, fontSize: 13 }}>
              {description}
            </Paragraph>
          )}
        </div>
      </Flex>

      <Tabs
        type="card"
        activeKey={activeKey}
        onChange={onChange}
        items={items}
        destroyOnHidden
        tabBarStyle={{ marginBottom: 24 }}
      />
    </Flex>
  );
}
